<template>
    <article class="ArticleApplication" v-if="ready" @click="selectedHotspot = null">

        <nav v-if="applications.length > 1">
            <button v-for="app in applications">{{ app.name }}</button>
        </nav>

        <div v-for="(app, index) in applications" :class="{ active: applicationIndex == index }" :key="app.id"
            class="ArticleApplication__app">
            <div class="ArticleApplication__text">
                <h3>{{ app.header }}</h3>
                <span v-html="app.text"></span>

                <a v-if="app.link && !isOffline" class="externallink" :href="app.link" target="_blank">
                    <span>
                        <IconGlobe></IconGlobe>
                    </span>
                    Learn more at deif.com
                </a>
            </div>


            <div class="ArticleApplication__appscene">
                <img :src="getExternalMediaPath(app.media.url)" @load="onImageLoad($event, index)">
                <div class="ArticleApplication__apphotspots">
                    <ApplicationHotspot v-for="hotspot in app.hotSpots" :hotspot="hotspot"
                        :style="[getHotspotPosition(hotspot, app)]" @click.stop="hotspotClicked(hotspot)">
                    </ApplicationHotspot>
                </div>
            </div>

        </div>

        <nav class="ArticleApplication__appselect" v-if="applications.length > 1">
            <button @click="applicationIndex = index" :class="{ active: index == applicationIndex }"
                v-for="(app, index) in applications">application
                {{ index + 1 }}</button>
        </nav>

        <article class="ArticleApplication__productcontainer" :class="{ active: selectedHotspot != null }" @click.stop>
            <button class="close btnfx btnfx__clickflash" @click="selectedHotspot = null"></button>
            <div v-for="(product, index) in selectedHotspot?.products" class="ArticleApplication__product"
                :class="{ active: index == productIndex }">
                <div class="text">
                    <h3>{{ product.productName }}</h3>
                    <img :src="getExternalMediaPath(product.media[0].url)" />
                    {{ cleanLinks(product.header) }}
                    <a :href="product.url" target="_blank" v-if="product.url && !isOffline">
                        <IconGlobe></IconGlobe> More about {{ product.productName }}
                    </a>
                </div>
            </div>

            <div class="rollbuttons" v-if="selectedHotspot && selectedHotspot.products.length > 1">
                <button class="back round btnfx btnfx__clickflash" @click="prevProduct()">
                    <IconArrowBack></IconArrowBack>
                </button>
                <span>{{ productIndex + 1 }} / {{ selectedHotspot.products.length }} </span>
                <button class="forth round btnfx btnfx__clickflash" @click="nextProduct()">
                    <IconArrowBack></IconArrowBack>
                </button>
            </div>

        </article>

    </article>

</template>


<script>
export default {
    props: ["properties"],
    data() {
        return {
            ready: false,
            applications: [],
            applicationIndex: 0,
            selectedApp: {},
            selectedHotspot: null,
            productIndex: 0,
        }
    },

    mounted() {

        this.ready = true;

        var externalApplications = app.api.externalManifest?.applications;

        this.properties.applicationList.forEach(app => {
            const matched = externalApplications?.find(application => application.id.toString() === app.appID);
            if (matched) {
                // add props from umbraco
                matched.header = app.header;
                matched.text = app.text;
                matched.link = app.link;
                // add to final object
                this.applications.push(matched);
            }
        });

        console.log(this.properties);
        console.log(this.applications);

    },
    methods: {

        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },
        getMediaPath(mediaUrl) {
            return app.api.Utils.getMediaPath(mediaUrl)
        },
        getExternalMediaPath(mediaUrl) {
            return app.api.Utils.getMediaPath(mediaUrl, true)
        },

        onImageLoad(event, index) {
            const img = event.target;
            const width = img.clientWidth;
            const height = img.clientHeight;

            this.applications[index].imageWidth = width;
            this.applications[index].imageHeight = height;
        },
        getHotspotPosition(hotspot, app) {
            if (!app.imageWidth || !app.imageHeight) return { left: '0px', top: '0px' };
            return {
                left: (hotspot.left / 100 * app.imageWidth - 20) + "px",
                top: (hotspot.right / 100 * app.imageHeight - 20) + "px"
            };
        },
        hotspotClicked(hotspot) {
            this.selectedHotspot = hotspot;
            this.productIndex = 0;
        },
        prevProduct() {
            this.productIndex = (this.productIndex + this.selectedHotspot.products.length - 1) % this.selectedHotspot.products.length;
        },
        nextProduct() {
            this.productIndex = (this.productIndex + 1) % this.selectedHotspot.products.length;
        },
        cleanLinks(str) {
            str = str.replace('Learn more here', '');
            str = str.replace('Learn more', '');
            str = str.replace(' .', '');
            return str;
        }

    },
    computed: {
        isOffline() {
            return (window.location.hostname === "");
        }
    }
};

</script>


<style lang="scss">
.ArticleApplication {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 55px 55px;
    display: flex;
    justify-content: center;

    &__app {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        pointer-events: none;
        opacity: 0;
        transition: opacity .3s;

        &.active {
            pointer-events: all;
            opacity: 1;
        }
    }

    &__appscene {
        position: absolute;
        width: 1130px;
        top: -100px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 20px;
        }
    }

    &__appselect {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        left: 55px;
        top: 300px !important;
        gap: 15px !important;

        button {
            height: 40px;
            padding: 0 20px;
            border-radius: 20px;
            background-color: #D9D9D9;
            color: var(--main-color);
            font-size: 16px;
            transition: background-color 0.2s;

            &.active {
                background-color: var(--main-color);
                color: #fff;
            }
        }
    }

    &__apphotspots {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;


        .hotspot {
            display: flex;

        }
    }

    &__text {
        position: absolute;
        bottom: 55px;
        left: 55px;
        right: 55px;
        height: fit-content;
        text-align: left;
        column-gap: 60px;
        column-count: 3;
        column-fill: balance;

    }



    &__productcontainer {
        position: absolute;
        width: 435px;
        height: 1028px;
        bottom: 0;
        right: 0;
        background-color: #D9D9D9;
        border-radius: 0 25px 25px 0;
        transform: translateX(110%);
        transition: transform .2s var(--quad-easeout);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
        z-index: 3;


        &.active {
            transform: translateX(0);

        }

        button.close {
            top: 20px;
            right: 20px;
        }

        .rollbuttons {
            width: 200px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: absolute;
            bottom: 50px;

            span {
                font-size: 16px;
                opacity: 0.5;
            }

            .forth {
                svg {
                    transform: rotate(180deg);
                }
            }
        }


    }

    &__product {
        position: absolute;
        opacity: 0;
        padding: 55px;
        transition: opacity 0.3s;
        pointer-events: none;



        &.active {
            opacity: 1;
            transition: opacity 0.3s 0.15s;
            pointer-events: all;
        }

        img {
            width: 100%;
            margin-bottom: 2em;
        }

        .text {
            max-height: 600px;
            overflow-y: auto;
            color: #000;
            font-weight: 400;
            font-size: 20px;
            font-style: normal;


            a {
                display: block;
                display: flex;
                justify-content: left;
                align-items: center;
                margin-top: 1em;
                color: var(--main-color);
                gap: 10px;
            }
        }
    }



    .externallink {
        display: flex;
        align-items: center;
        margin-top: 1em;

        span {
            height: 40px;
            width: 40px;
            background: var(--secondary-color);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
        }
    }

}
</style>
